// This file is auto-generated by the build system.
export const BUILD_DATE: string = "Tue, 15 Feb 2022 21:37:17 GMT";
export const PACKAGE_NAME: string = "html-living-framework";
export const PACKAGE_VERSION: string = "2.0.0";
export const GIT_BRANCH: string | undefined = "pixi-v6";
export const GIT_COMMIT: string | undefined = "9c537bb361647208821c1d020de0b8a8f0f65cc9";
